/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { IncludedResource, User } from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Me<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags sessions
   * @name GetMe
   * @summary ログインユーザーの情報を取得する
   * @request GET:/me
   */
  getMe = (params: RequestParams = {}) =>
    this.request<
      {
        data: User;
        included?: IncludedResource[];
      },
      void
    >({
      path: `/me`,
      method: "GET",
      type: ContentType.UrlEncoded,
      ...params,
    });
}
